"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deriveComplianceLevel = deriveComplianceLevel;
/**
 * Derive the overall compliance level from individual criterion booleans.
 *
 * - All true → `signed-off`
 * - Some true (but not all) → `partial`
 * - None true → `not-started`
 */
function deriveComplianceLevel(criteria) {
    const values = Object.values(criteria);
    const passed = values.filter(Boolean).length;
    if (passed === values.length)
        return 'signed-off';
    if (passed === 0)
        return 'not-started';
    return 'partial';
}
